import { makeHttpRequest } from "@/shared";

export const deletePaymentTypes = async (ids) => {
    const response = (
        await makeHttpRequest({
            url: "/payment-type/delete-multiple",
            method: "DELETE",
            params: { items: ids },
        })
    ).data;

    return response;
};
